import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { useConfiguration } from '~/contexts/ConfigurationProvider';
import { CreateClientForm } from '~/features/CreateClientForm';
import { LegacyCreateClientForm } from '~/features/LegacyCreateClientForm';
import { getEnvFeatureFlag } from '~/utils/getEnvFeatureFlag';
import styles from './index.module.scss';

export const Screen: React.FC = () => {
  const { applicationConfiguration } = useConfiguration();
  const { enableStaging } = getEnvFeatureFlag();

  // API連携モードの場合は利用企業一覧にリダイレクト
  if (applicationConfiguration?.application_configuration.is_api_integration) {
    return <Navigate to='/clients' replace />;
  }

  return (
    <>
      <PageHeader
        variant='breadcrumb'
        breadcrumbItems={[{ label: '利用企業', href: '/clients' }, { label: '新規作成' }]}
      />
      <div className={styles.content}>
        <Suspense fallback={<Loader />}>
          {/* enableStaging が ON（staging / development）のときのみ新フォームを表示 */}
          {enableStaging ? <CreateClientForm /> : <LegacyCreateClientForm />}
        </Suspense>
      </div>
    </>
  );
};
